<template>
	<li class="post row py-0 mx-0 align-items-center private-note-hover" style="min-height: 60px; display: flex">
		<div class="col px-0 py-2">
			<div class="row my-auto mx-0">

			<div v-if="isEditableVal">
				<span class="column-drag-handle grabbable"><i class="fontello icon-menu"></i></span>
			</div>
			<div>
				<i class="fontello icon-edit mr-2"/>

			</div>
			<div class="col p-0">
				<div>{{ programStep.name || 'Note'}}</div>
				<div v-if="programStep.goal.length > 0" class="text-muted"><small>{{ 'Goal: ' + programStep.goal}}</small></div>
				<small class="text-muted">
					<div v-if="!programStep.isOwner(userProfile.id)">
						<div>a note from {{userProfile.isCoach() ? "client" : "coach"}}</div>
						<div>created on {{programStep.createdAtFormatted()}}</div>
					</div>
				</small>
			</div>
			<div>

			<div class="float-right text-right">
				<small>
					<div>
						<div v-if="programStep.isPublic()">
							<el-tooltip v-if="isInCoachMode" class="item" :enterable=false effect="dark" placement="right">
<!--								<i class="fontello icon-lock-open"/>-->
								<template #content>
									<div style="max-width: 240px;">
										This is a shared note which is visible to you and your client.
									</div>
								</template>
							</el-tooltip>

<!--							<span> </span><i class="fontello icon-lock-open"/>-->
						</div>
						<div v-else>
							Private note
							<ToolTipView class="item"
										 :analyticsProps="{label: 'Private note', ...analyticsPropsMethod()}">
								<template #icon><i  class="fontello icon-lock no-margin"/></template>
								<div style="max-width: 240px;">
									This is a private note which is visible only to you.
								</div>
							</ToolTipView>
<!--							<span> </span><i class="fontello icon-lock"/>-->
						</div>
					</div>
				</small>
			</div>
			</div>
		</div>
		</div>
	</li>
</template>

<script>
	import BaseRow from "./BaseRow"
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

	export default {
		name: "NoteRow",
		components: {ToolTipView},
		extends: BaseRow,
	}
</script>

<style>

</style>
